(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-info"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__deliveryInfoInit) return;
    window.__deliveryInfoInit = true;

    var TIMEZONE = 'Australia/Melbourne';
    var CUTOFF_HOUR = 16;

    function nowInTZ() {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: TIMEZONE,
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (part) {
        map[part.type] = part.value;
      });
      return new Date(Date.UTC(+map.year, +map.month - 1, +map.day, +map.hour, +map.minute, +map.second));
    }

    function isWeekend(date) {
      var day = date.getUTCDay();
      return day === 0 || day === 6;
    }

    function addBusinessDays(date, count) {
      var result = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
      var added = 0;
      while (added < count) {
        result.setUTCDate(result.getUTCDate() + 1);
        if (!isWeekend(result)) added += 1;
      }
      return result;
    }

    function nextCutoff(now) {
      var todayCutoff = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), CUTOFF_HOUR, 0, 0));
      if (!isWeekend(now) && now.getTime() < todayCutoff.getTime()) {
        return todayCutoff;
      }
      var next = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
      do {
        next.setUTCDate(next.getUTCDate() + 1);
      } while (isWeekend(next));
      return new Date(Date.UTC(next.getUTCFullYear(), next.getUTCMonth(), next.getUTCDate(), CUTOFF_HOUR, 0, 0));
    }

    function formatDate(date) {
      return new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(date);
    }

    function formatDuration(ms) {
      var totalMinutes = Math.max(0, Math.ceil(ms / 60000));
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;
      return hours + 'hr, ' + minutes + 'min';
    }

    function initRoot(root) {
      var days = parseInt(root.dataset.deliveryDays || '2', 10);
      var dateEl = root.querySelector('[data-delivery-eta-date]');
      var timerEl = root.querySelector('[data-delivery-timer]');
      if (!dateEl && !timerEl) return;

      var cutoff = nextCutoff(nowInTZ());

      function renderDate() {
        var eta = addBusinessDays(nowInTZ(), days);
        if (dateEl) dateEl.textContent = formatDate(eta);
      }

      function tick() {
        var now = nowInTZ();
        if (now.getTime() >= cutoff.getTime()) {
          cutoff = nextCutoff(now);
          renderDate();
        }
        if (timerEl) timerEl.textContent = formatDuration(cutoff.getTime() - now.getTime());
      }

      renderDate();
      tick();
      setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-delivery-info]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__megaMenuHoverInit) return;
    window.__megaMenuHoverInit = true;

    // Only one dropdown is ever open: opening one closes the others at once,
    // so menus can no longer stack on top of each other.
    var CLOSE_DELAY = 180;
    var menus = Array.prototype.slice.call(document.querySelectorAll('[data-mega-menu]'));
    var closeTimer = null;
    var current = null;

    function closeAll(except) {
      menus.forEach(function (m) {
        if (m !== except) m.classList.remove('is-open');
      });
    }

    function open(menu) {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (current !== menu) closeAll(menu);
      current = menu;
      menu.classList.add('is-open');
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeAll(null);
        current = null;
        closeTimer = null;
      }, CLOSE_DELAY);
    }

    menus.forEach(function (menu) {
      menu.addEventListener('mouseenter', function () { open(menu); });
      menu.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('focusin', function () { open(menu); });
      menu.addEventListener('focusout', function (event) {
        if (!menu.contains(event.relatedTarget)) scheduleClose();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purchase-plan"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__purchasePlanDelegated) return;
    window.__purchasePlanDelegated = true;

    function getSelectedVariant() {
      var script = document.querySelector('[data-selected-variant]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function isMonthlyVariant(root, variant) {
      if (!variant) return false;
      var match = root.dataset.monthlyMatch || 'monthly';
      var title = (variant.title || '').toLowerCase();
      if (title.indexOf(match) !== -1) return true;
      var options = variant.options || [];
      return options.some(function (value) {
        return (value || '').toLowerCase().indexOf(match) !== -1;
      });
    }

    function decorateOptionBoxes(root) {
      var optionName = root.dataset.optionName;
      if (!optionName) return;
      var match = root.dataset.monthlyMatch || 'monthly';
      var inputs = document.querySelectorAll(
        'input[type="radio"][data-option-name="' + optionName.replace(/"/g, '\\"') + '"]'
      );
      inputs.forEach(function (input) {
        input.setAttribute('data-purchase-plan-option', '');
        var label = document.querySelector('label[for="' + input.id + '"]');
        if (!label || label.querySelector('.purchase-plan__option-subtext')) return;
        var isMonthly = (input.value || '').toLowerCase().indexOf(match) !== -1;
        var text = isMonthly ? root.dataset.monthlyText : root.dataset.prepaidText;
        var badgeText = isMonthly ? root.dataset.monthlyBadge : root.dataset.prepaidBadge;

        var check = document.createElement('span');
        check.className = 'purchase-plan__check';
        check.setAttribute('aria-hidden', 'true');
        check.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 13l4 4L19 7"/></svg>';
        label.appendChild(check);

        if (badgeText) {
          var badge = document.createElement('span');
          badge.className = 'purchase-plan__badge';
          badge.textContent = badgeText;
          label.appendChild(badge);
        }

        if (!text) return;
        var subtext = document.createElement('span');
        subtext.className = 'purchase-plan__option-subtext';
        text.split('\n').forEach(function (line, index) {
          if (!line.trim()) return;
          var lineEl = document.createElement('span');
          lineEl.className = 'purchase-plan__option-subtext-line' + (index > 0 ? ' purchase-plan__option-subtext-line--muted' : '');
          lineEl.textContent = line.trim();
          subtext.appendChild(lineEl);
        });
        label.appendChild(subtext);
      });
    }

    function syncCheckmarks(root) {
      var optionName = root.dataset.optionName;
      if (!optionName) return;
      var inputs = document.querySelectorAll(
        'input[type="radio"][data-option-name="' + optionName.replace(/"/g, '\\"') + '"]'
      );
      inputs.forEach(function (input) {
        var label = document.querySelector('label[for="' + input.id + '"]');
        var check = label && label.querySelector('.purchase-plan__check');
        if (!check) return;
        check.classList.toggle('purchase-plan__check--active', input.checked);
      });
    }

    function initDecoration() {
      var root = document.querySelector('[data-purchase-plan]');
      if (!root) return;
      decorateOptionBoxes(root);
      syncCheckmarks(root);

      var productInfo = document.querySelector('product-info');
      if (!productInfo || productInfo.dataset.purchasePlanObserved) return;
      productInfo.dataset.purchasePlanObserved = 'true';

      new MutationObserver(function () {
        var currentRoot = document.querySelector('[data-purchase-plan]');
        if (currentRoot) {
          decorateOptionBoxes(currentRoot);
          syncCheckmarks(currentRoot);
        }
      }).observe(productInfo, { childList: true, subtree: true });

      document.addEventListener('change', function (event) {
        if (!event.target.matches('input[data-purchase-plan-option]')) return;
        var currentRoot = document.querySelector('[data-purchase-plan]');
        if (currentRoot) syncCheckmarks(currentRoot);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDecoration);
    } else {
      initDecoration();
    }

    document.addEventListener(
      'click',
      function (event) {
        var confirmButton = event.target.closest('[data-purchase-plan-confirm]');
        if (confirmButton) {
          var dialogToClose = confirmButton.closest('[data-purchase-plan-dialog]');
          if (dialogToClose) dialogToClose.close();
          var form = confirmButton.closest('product-info')
            ? confirmButton.closest('product-info').querySelector('form[data-type="add-to-cart-form"]')
            : document.querySelector('form[data-type="add-to-cart-form"]');
          var submitButton = form && form.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.dataset.purchasePlanBypass = 'true';
            submitButton.click();
          }
          return;
        }

        var cancelButton = event.target.closest('[data-purchase-plan-cancel]');
        if (cancelButton) {
          var dialogToCancel = cancelButton.closest('[data-purchase-plan-dialog]');
          if (dialogToCancel) dialogToCancel.close();
          return;
        }

        var submit = event.target.closest('button[type="submit"]');
        if (!submit) return;

        if (submit.dataset.purchasePlanBypass) {
          delete submit.dataset.purchasePlanBypass;
          return;
        }

        var root = document.querySelector('[data-purchase-plan]');
        if (!root) return;

        var productInfo = submit.closest('product-info');
        if (!productInfo || !productInfo.contains(root)) return;

        if (root.dataset.confirmMonthly !== 'true') return;

        var variant = getSelectedVariant();
        if (!isMonthlyVariant(root, variant)) return;

        var dialog = root.querySelector('[data-purchase-plan-dialog]');
        if (!dialog) return;

        var totalEl = root.querySelector('[data-purchase-plan-total]');
        if (totalEl && variant) {
          totalEl.textContent = totalEl.dataset.label + ' = ' + formatMoney(variant.price);
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        dialog.showModal();
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["welcome-popup"] && !Shopify.designMode) return;
  try {
    (function () {
      if (window.__welcomePopupDelegated) return;
      window.__welcomePopupDelegated = true;

      var STORAGE_KEY = 'tm_welcome_popup_seen';
      var PENDING_KEY = 'tm_welcome_discount_pending';
      var DISCOUNT_REDIRECT = '/discount/WELCOME10?redirect=/';
      var SHOW_DELAY_MS = 4000;

      // Completes the discount-apply redirect that the form's own
      // return_to field doesn't reliably do (see the doc comment above).
      // This flag is set right before the native submit below, survives
      // that full-page submit/reload because sessionStorage is scoped to
      // the tab rather than the page, and is checked first on every load -
      // before anything else here, so it fires as early as possible on
      // whatever page Shopify happens to land the browser back on.
      try {
        if (window.sessionStorage.getItem(PENDING_KEY) === '1') {
          window.sessionStorage.removeItem(PENDING_KEY);
          window.location.replace(DISCOUNT_REDIRECT);
          return;
        }
      } catch (e) {
        // ignore storage failures (private browsing, etc.) - worst case
        // the redirect is skipped, same as the pre-existing behavior.
      }

      function init() {
        var root = document.querySelector('[data-welcome-popup]');
        if (!root) return;
        var dialog = root.querySelector('[data-welcome-popup-dialog]');
        if (!dialog) return;

        var alreadySeen = false;
        try {
          alreadySeen = window.localStorage.getItem(STORAGE_KEY) === 'true';
        } catch (e) {
          alreadySeen = false;
        }
        if (alreadySeen) return;

        function markSeen() {
          try {
            window.localStorage.setItem(STORAGE_KEY, 'true');
          } catch (e) {
            // ignore storage failures (private browsing, etc.)
          }
        }

        setTimeout(function () {
          if (dialog.open) return;
          dialog.showModal();
          markSeen();
        }, SHOW_DELAY_MS);

        root.querySelector('[data-welcome-popup-close]').addEventListener('click', function () {
          dialog.close();
        });

        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) dialog.close();
        });

        dialog.querySelector('form').addEventListener('submit', function () {
          markSeen();
          try {
            window.sessionStorage.setItem(PENDING_KEY, '1');
          } catch (e) {
            // ignore storage failures (private browsing, etc.) - worst
            // case the discount redirect is skipped, same as before.
          }
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
